import React, { useEffect } from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Tooltip);

const Analytics = ({ data,avgCountPerMinute, dropDown }) => {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: "Count",
        data: data.values,
        borderColor: "orange",
        backgroundColor: "rgba(255, 165, 0, 0.3)",
        borderWidth: 2,
        tension: 0.4,

      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        ticks: {
          callback: function (value) {
            // Ensure only integers are displayed
            return Number.isInteger(value) ? value : null;
          },
        },
        beginAtZero: true, // Start the Y-axis from 0
      },
      x: {
        ticks: {
          autoSkip: true, // Optional: Skips ticks for better readability
          maxRotation: 45, // Controls label rotation
          minRotation: 0,
        },
      },
    },
  };
  

  // const chartOptions = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   plugins: {
  //     legend: {
  //       display: false,
  //     },
  //   },
  // };
  
  // useEffect(()=>{
  //   sessionStorage.setItem("selectedAnalyticKey", selectedValue);
  // },[selectedValue])
  return (
    <Card
      sx={{
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        padding: "0",
        height: "100%"
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
           {avgCountPerMinute?.toFixed(2)}/Min
          </Typography>
          
        </Box>
        <div style={{ height: "250px" , width:"100%", overflowX:"scroll", paddingBottom:"20px" }}>
          <Line width={"100%"} data={chartData} options={chartOptions} />
        </div>
      </CardContent>
    </Card>
  );
};

export default Analytics;